module.exports = __webpack_public_path__ + "img/font-weight.0524c9d7.svg";